const ONE_DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24

export function daysInTimeframe(timeframe) {
  const startDate = Date.parse(timeframe.start)
  const endDate = Date.parse(timeframe.end)

  return Math.round(Math.abs((startDate - endDate) / ONE_DAY_IN_MILLISECONDS))
}
